// Story 175 (contract §1/§2, RN3) -- the ONE list of parameters the new plan-metrics reads (machine detail
// and deliveries) take from the Planner: its four applied global filters and, only if the ribbon ever sends
// it, the same `timeZone`. The load-capacity block's local controls (`reading`, `grouping`,
// `deviceGroupId`, `ungrouped`, `deviceId`) and the details table's own state (its "Asset" selector, its
// delivery-status filter) never travel from here.
const GLOBAL_PARAM_KEYS = ['fabricationOrderId', 'partReferenceId', 'orderId', 'clientId', 'timeZone']

export const toGlobalParams = (plannerFilters = {}) => GLOBAL_PARAM_KEYS.reduce((params, key) => {
  if (plannerFilters[key] !== null && plannerFilters[key] !== undefined) {
    params[key] = plannerFilters[key]
  }
  return params
}, {})
